// extracted by mini-css-extract-plugin
export default {"melodyVideo":"DI-z","isFullWidth":"EI-z","landingPageVideo":"FI-z","play":"GI-z","iframeVideo":"HI-z","playHidden":"II-z","fullwidth":"JI-z"};